import React from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import {faCode, faGear, faMoneyBill, faTrophy, faUniversity} from "@fortawesome/free-solid-svg-icons";
import {faBattleNet} from "@fortawesome/free-brands-svg-icons";

const AccountMenu = () => {
    const menu = [
        {text: 'دوره‌های من', link: '/account/course', icon: faUniversity},
        {text: 'لیگ برتر', link: '/account/league', icon: faTrophy},
        {text: 'خرید‌ها', link: '/account/purchases', icon: faMoneyBill},
        {text: 'تنظیمات', link: '/account/settings', icon: faGear},
    ];

    return <>
        <div
            className='w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100'>
            <ul className='list-none'>
                {
                    menu.map((item, index) => {
                        return (<li key={index} className='flex first:rounded-t-md last:rounded-b-md transition justify-center last:border-b-0 items-center p-5 cursor-pointer border-b-2 border-gray-200 m-0 hover:bg-gray-200'><Link to={item.link}>
                            <FontAwesomeIcon icon={item.icon} className='ml-3' size='lg'/>
                            <span>{item.text}</span>
                        </Link></li>);
                    })
                }
            </ul>
        </div>
    </>;
}

export default AccountMenu;